import { type } from './utils'

export default function isPromise(obj) {
	return type(obj) === 'Promise'
}
